var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4892 6.65632C11.1811 6.65632 11.7421 6.09636 11.7421 5.40561C11.7421 4.71487 11.1811 4.15491 10.4892 4.15491C9.79726 4.15491 9.23633 4.71487 9.23633 5.40561C9.23633 6.09636 9.79726 6.65632 10.4892 6.65632Z",
    fillOpacity: 0,
    stroke: "#6b6f7b",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2478 2.41145C14.2478 1.99273 13.9079 1.65344 13.4885 1.65344C13.4411 1.65344 8.97025 1.65405 8.97025 1.65405C8.5663 1.65405 8.17966 1.63282 7.95551 1.85659L1.05213 8.74782C0.827676 8.97159 0.827676 9.33482 1.05213 9.55859L6.32906 14.8265C6.55321 15.0502 6.91707 15.0502 7.14122 14.8265L14.0443 7.93493C14.2684 7.71147 14.2472 7.33458 14.2472 6.92223C14.2472 6.92223 14.2478 2.45875 14.2478 2.41145Z",
    stroke: "#6b6f7b",
    fillOpacity: 0,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.29dbe792ae356cc1d694a75cea2722a1.svg";
export { ForwardRef as ReactComponent };